import { render, staticRenderFns } from "./deviceInfo.vue?vue&type=template&id=68f7a293&scoped=true"
import script from "./deviceInfo.vue?vue&type=script&lang=js"
export * from "./deviceInfo.vue?vue&type=script&lang=js"
import style0 from "./deviceInfo.vue?vue&type=style&index=0&id=68f7a293&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f7a293",
  null
  
)

export default component.exports